import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { setSelectedPath } from '../../../../../../../slices/feeds/reducer';
import { toggleAddFieldModal, toggleCreateFeedModal, toggleSelectPathModal } from '../../../../../../../slices/modals/reducer';
import classnames from "classnames";
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, Row, Col, Label, FormFeedback, Input, Button, Spinner, Card, CardBody, Alert } from "reactstrap";
import ModalSelectBox from '../../../../../../Feeds/FeedLibrary/ModalSelectBox';
import { getFields } from '../../../../../../../slices/feeds/thunk';
import Preloader from '../../../../../../../Components/Common/Preloader';
import { getStylesFromCreativeObj, setCreativesDynamicText, setDynamicTextTag } from '../../../../../../../slices/campaigns/thunk';
import { setActiveDynamicText, setFacebookPropertyFeed } from '../../../../../../../slices/campaigns/reducer';

function SelectPathModal() {
  const dispatch = useDispatch();

  const selectStates = createSelector((state) => state, (state) => ({
    pathModal: state.Modal.selectPathModal,
    selectPathModalKind: state.Modal.selectPathModalKind,
    selectPathLoader: state.Modal.selectPathLoader,
    selectedPath: state.Feed.selectedPath,
    connectedFeed: state.Campaign.connectedFeed,
    connectedFeedName: state.Campaign.connectedFeedName,
    selectedTag: state.Campaign.selectedTag,
    activeDynamicText: state.Campaign.activeDynamicText,
    selectedFacebookProperty: state.Campaign.selectedFacebookProperty,
    facebookProperties: {
      id: state.Campaign.id,
      title: state.Campaign.title,
      description: state.Campaign.description,
      availability: state.Campaign.availability,
      condition: state.Campaign.condition,
      price: state.Campaign.price,
      link: state.Campaign.link,
      image_link: state.Campaign.image_link,
    },
    selectedCreative: state.Campaign.selectedCreative,
  }));
  const {
    pathModal,
    selectPathModalKind,
    selectPathLoader,
    selectedPath,
    connectedFeed,
    connectedFeedName,
    selectedTag,
    activeDynamicText,
    selectedFacebookProperty,
    facebookProperties,
    selectedCreative
  } = useSelector(selectStates);

  function handleSelect(item, idx) {
    dispatch(setSelectedPath({ ...item, idx: idx }));
  }

  async function linkFeedPathToDynamicText() {
    let updatedDynamicText;
    if (selectedCreative) {
      if (dynamicText.find(item => (item.isCreative === true) && (item.creativeId === selectedCreative._id))) {
        updatedDynamicText = await dispatch(setDynamicTextTag({
          ...selectedTag,
          value: selectedPath?.path,
          isFeed: true
        }));
      } else {
        const newTexts = [];
        dynamicText[0].texts.forEach(item => {
          if (item.tag === selectedTag?.tag) {
            newTexts.push({ ...item, value: selectedPath.path, isFeed: true });
          } else {
            newTexts.push(item);
          }
        });
        const newDynamicTextObj = { ...dynamicText[0], texts: newTexts, isCreative: true, creativeId: selectedCreative?._id };
        delete newDynamicTextObj._id;
        updatedDynamicText = newDynamicTextObj;
        dispatch(setDynamicText([...dynamicText, newDynamicTextObj]));
      }
    } else {
      updatedDynamicText = await dispatch(setDynamicTextTag({
        ...selectedTag,
        value: selectedPath?.path,
        isFeed: true
      }));
    }
    dispatch(setCreativesDynamicText());
    dispatch(setActiveDynamicText(null));
    setTimeout(() => {
      dispatch(setActiveDynamicText(updatedDynamicText));
    }, 1);
    dispatch(toggleSelectPathModal());
  }

  async function removeFeedPathDynamicText() {
    const updatedDynamicText = await dispatch(setDynamicTextTag({ ...selectedTag, value: '', style: '', isFeed: false }));
    dispatch(setCreativesDynamicText());
    dispatch(setActiveDynamicText(null));
    setTimeout(() => {
      dispatch(setActiveDynamicText(updatedDynamicText));
    }, 1);
    dispatch(toggleSelectPathModal());
  }

  async function linkFeedPathToFacebookProperty() {
    const foundFeed = connectedFeed.find(item => item.path === selectedPath.path);
    dispatch(setFacebookPropertyFeed({ isFeed: true, value: selectedPath.path, name: foundFeed.values[0] }));
    dispatch(toggleSelectPathModal());
  }

  async function linkFeed() {
    if (selectPathModalKind === 'dynamicText') {
      await linkFeedPathToDynamicText();
    } else if (selectPathModalKind === 'facebookProperty') {
      await linkFeedPathToFacebookProperty();
    }
  }

  async function removeFeedPathFacebookProperty() {
    dispatch(setFacebookPropertyFeed({ isFeed: false, value: '', name: '' }));
    dispatch(toggleSelectPathModal());
  }

  async function removeFeed() {
    if (selectPathModalKind === 'dynamicText') {
      await removeFeedPathDynamicText();
    } else if (selectPathModalKind === 'facebookProperty') {
      await removeFeedPathFacebookProperty()
    }
  }

  return (
    <Modal isOpen={pathModal} toggle={() => dispatch(toggleSelectPathModal())} centered size="lg">
      <ModalHeader className='p-3' toggle={() => { dispatch(toggleSelectPathModal()) }}>
        Dynamic Content
      </ModalHeader>
      <ModalBody>
        {selectPathLoader ?
          <Preloader isComponentLoader={true} />
          : (connectedFeedName && !connectedFeed) ?
            <React.Fragment>
              <Alert className='d-flex align-items-center' color="danger">
                <p className='m-0'>
                  <i class="ri-error-warning-line me-2 align-middle fs-17"></i>
                  There seems to be an issue with your data feed. Please go to the Feed section in the application to review and fix it.
                </p>
              </Alert>
            </React.Fragment>
            :
            <React.Fragment>
              <Row>
                <Col>
                  <div className='w-100 mb-2 d-flex align-items-center justify-content-between'>
                    <p className='text-body m-0'>Feed Items</p>
                    {selectPathModalKind === 'dynamicText' ? activeDynamicText && activeDynamicText?.texts ?
                      activeDynamicText?.texts.find(item => item.tag === selectedTag?.tag)?.isFeed ?
                        <button className='btn btn-danger' onClick={removeFeed}>
                          Disconnect Feed Item
                        </button>
                        : null : null :
                      selectPathModalKind === 'facebookProperty' ?
                        facebookProperties[selectedFacebookProperty]?.isFeed ?
                          <button className='btn btn-danger' onClick={removeFeed}>
                            Disconnect Feed Item
                          </button>
                          : null : null}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className='bg-light'>
                    {connectedFeed && (connectedFeed || []).map((item, idx) => {
                      if (item && item.values && typeof item.values[0] !== 'object' && !Array.isArray(item.values[0])) {
                        return (
                          <ModalSelectBox
                            key={idx}
                            name={item.name}
                            values={item.values[0] ? item.values[0] : ''}
                            icon={"ri-code-line"}
                            classnames={classnames({ "bg-info-subtle": (selectedPath?.path === item.path || facebookProperties[selectedFacebookProperty]?.value === item.path) })}
                            handleSelect={() => handleSelect(item, idx)}
                          />
                        )
                      }
                    })}
                  </div>
                </Col>
              </Row>
            </React.Fragment>
        }
      </ModalBody>
      <ModalFooter>
        <Button color='light' onClick={() => dispatch(toggleSelectPathModal())}>Close</Button>
        {selectedPath !== null ?
          <Button color='success' onClick={linkFeed}>Save Settings</Button>
          : null}
      </ModalFooter>
    </Modal>
  )
}

export default SelectPathModal
